import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kCsvCore } from "../../../Admin/kReusableCoreTS/kCsvCore";

// AppCsvLine - ONE line of an Excel-friendly CSV file for both halves: `/export` (`ExportRules.Line`, the service) and
// the Revenue export (`AppMoneyCsv`, the page). RFC 4180 with CRLF, quoted on `"` CR LF or EITHER separator, a `'`
// before a formula start (CSV injection). ⚠ Habitat-free - the Bridge imports it. Pinned byte for byte by `ExportRun.test.ts`.

export class AppCsvLine {
    public static readonly Eol: string = "\r\n";

    /** One CRLF-terminated line, cells joined by `Sep` ("," or ";" - the caller has already decided which). */
    public static Line = (Cells: string[], Sep: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return kCsvCore.Line(Cells, Sep, { QuoteAlso: ",;", GuardFormulas: true }, AppCsvLine.Eol);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppCsvLine.Line");
            return "";
        }
    };
}
